import React from 'react';

interface Option {
  id: number;
  label: string;
  image?:string
}

interface Props {
  options: Option[];
  selected: number | null;
  onSelect: (id: number) => void;
  className?: string;
}

const ButtonSelect: React.FC<Props> = ({ options, selected, onSelect, className }) => {
  const buttonStyle = (active: boolean) =>
    `px-4 py-2 rounded-[100px] border transition flex gap-1 items-center ${
      active ? 'bg-primaryButton text-white' : 'bg-LightGrey1  text-gray-700'
    }`;

  return (
    <div className={`flex gap-2 ${className || ''}`}>
      {options.map(option => (
        <button
          key={option.id}
          type="button"
          onClick={() => onSelect(option.id)}
          className={`${buttonStyle(selected === option.id)}`}
        >
            {option.image && <img src={option.image} alt={option.label} className='w-4 h-4'/>}
            <span>{option.label}</span>
        </button>
      ))}
    </div>
  );
};

export default ButtonSelect;
